module.exports = {"order":0,"item":"controlToggle","size":{"sm":12,"md":6,"lg":6,"xl":3},"data":{"name":"Switch","desc":"two position switch","position":{"name":"Position","visibility":true,"tag":{"id":"0","text":"noTag"},"tagBit":{"id":"99","text":"noBit"},"tagEmergency":{"id":"0","text":"noTag"},"tagBitEmergency":{"id":"99","text":"noBit"},"boolConfig":{"trueMsg":"On","trueColor":{"id":"danger","text":"Danger"},"falseMsg":"Off","falseColor":{"id":"success","text":"Success"}}}}}


//////////////////
// WEBPACK FOOTER
// ./src/views/site/Developer/DeveloperOverviewRender/Components/Data/controlToggle.json
// module id = 868
// module chunks = 0